import React from 'react';
import TablaClaseMinas from '../components/minas/tablaClaseMinas';

function ClassMinas() {
  return (
    <div className='col-sm-12 d-flex justify-content-center row p-0 m-0'>
        <TablaClaseMinas />
    </div>

  );
}

export default ClassMinas;




// WEBPACK FOOTER //
// ./src/pages/claseminas.js